import message from 'ant-design-vue/es/message'
// import defaultSettings from '../defaultSettings';
import themeColor from './themeColor.js'

// let lessNodesAppended
// const colorList = [
//   {
//     key: '薄暮', color: '#F5222D'
//   },
//   {
//     key: '火山', color: '#FA541C'
//   },
//   {
//     key: '日暮', color: '#FAAD14'
//   },
//   {
//     key: '明青', color: '#13C2C2'
//   },
//   {
//     key: '极光绿', color: '#52C41A'
//   },
//   {
//     key: '拂晓蓝（默认）', color: '#1890FF'
//   },
//   {
//     key: '极客蓝', color: '#2F54EB'
//   },
//   {
//     key: '酱紫', color: '#722ED1'
//   }
// ]

const colorList  =  [
	{key: '橙色', color: '#E85827'},
	{key: '蓝色', color: '#2C62C4'},
	{key: '深蓝', color: '#002EA6'},
	{key: '绿色', color: '#7FA91F'},
	{key: '火焰红', color: '#C8161D'},
	{key: '酒红', color: '#800020'}, 
	{key: '普鲁士蓝', color: '#003153'}, 
	{key: '马尔斯绿', color: '#008C8C'}, 
]
const updateTheme = newPrimaryColor => {
  const hideMessage = message.loading('正在切换主题！', 0)
  themeColor.changeColor(newPrimaryColor).then(r => {
    setTimeout(()=>{
      hideMessage()
    }, 10)
  })
}

const updateColorWeak = colorWeak => {
  // document.body.className = colorWeak ? 'colorWeak' : '';
  const app = document.body.querySelector('#app')
  colorWeak ? app.classList.add('colorWeak') : app.classList.remove('colorWeak')
}

export { updateTheme, colorList, updateColorWeak }
